// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"50f7e691","66":"c8c02d0d","657":"b16d7a8d","870":"5bd35a31"}[chunkId] + ".chunk.js";
};